(() => {
  angular.module('finance').component('organizationUtilizationInvoiceDetailComponent', {
    templateUrl: require('./organizationUtilization.component.html'),
    controller: OrganizationUtilizationInvoiceDetailComponent,
    controllerAs: 'vm',
    bindings: {
      currencyCode: '<',
      invoice: '<',
      invoiceFrom: '<',
      invoiceTo: '<',
      isAddressInvoiceFrom: '<',
      isAddressInvoiceTo: '<',
      message: '<',
      getDateString: '<'
    },
  });

  OrganizationUtilizationInvoiceDetailComponent.$inject = [];

  function OrganizationUtilizationInvoiceDetailComponent() {
    const vm = this;

    vm.loading = 0;

    init();

    function init() {}
  }
})();
